// 路由信息，纯JS对象，方便读取路由信息
import Router from 'vue-router';
import Home from './views/Home.vue';
import QreaQuery from './views/area-query.vue';
import AreaTable from './views/area-table.vue';
import NucleicTestTable from './views/nucleic-test-table.vue';
import StationTable from './views/station-table.vue';
import CardList from './views/card-list.vue';
import Overseas from './views/overseas.vue';

export enum RouteName {
  home = 'home',
  areaQuery = 'areaQuery',
  areaTable = 'areaTable',
  stationTable = 'stationTable',
  nucleicTestTable = 'nucleicTestTable',
  cases = 'cases',
  overseas = 'overseas'
}

export default new Router({
  routes: [
    {
      path: '/',
      name: RouteName.home,
      component: Home,
    },
    {
      path: '/areaQuery/:pageType',
      name: RouteName.areaQuery,
      component: QreaQuery,
      props: true,
    },
    {
      path: '/areaTable/traffic',
      name: RouteName.areaTable,
      component: AreaTable,
      props: true,
    },
    {
      path: '/areaTable/nucleicTest',
      name: RouteName.nucleicTestTable,
      component: NucleicTestTable,
      props: true,
    },
    {
      path: '/areaTable/station',
      name: RouteName.stationTable,
      component: StationTable,
      props: true,
    },
    {
      path: '/cardList/cases',
      name: RouteName.cases,
      component: CardList,
      props: true,
    },
    {
      path: '/overseas',
      name: RouteName.overseas,
      component: Overseas,
      props: true,
    },
  ],
});
